import { useMemo } from 'react';

import type { GridOptions } from 'ag-grid-community';

export const useDefaultGridOptions = (): GridOptions => {
  return useMemo<GridOptions>(
    () => ({
      columnMenu: 'new',
    }),
    [],
  );
};
